import "./SectionTwo.css";

import React from "react";

import { useRef } from "react";

import secondSectionStart from "../../../../shared/imageAssets/secondSectionStart.png";

import { SectionTwoCard } from "./SectionTwoCard";

import sectionTwoIcon1 from "../../../../shared/imageAssets/sectionTwoIcon1.png";
import sectionTwoIcon2 from "../../../../shared/imageAssets/sectionTwoIcon2.png";
import sectionTwoIcon3 from "../../../../shared/imageAssets/sectionTwoIcon3.png";
import sectionTwoIcon4 from "../../../../shared/imageAssets/sectionTwoIcon4.png";
import sectionTwoSignatureIcon from "../../../../shared/imageAssets/sectionTwoSignatureIcon.png";

export const SectionTwo = () => {
  const singleCardRef = useRef(null);
  const multiCardRef1 = useRef(null);
  const multiCardRef2 = useRef(null);

  const singleCardOnload = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("single-card-animation");
        }
      });
    });
    observer.observe(singleCardRef.current);
  };

  const multiCardOnload1 = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("multi-card-animation-1");
        }
      });
    });
    observer.observe(multiCardRef1.current);
  };

  const multiCardOnload2 = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("multi-card-animation-2");
        }
      });
    });
    observer.observe(multiCardRef2.current);
  };

  return (
    <div className="section-two-container">
      <img style={{ margin: 0, width: "100%" }} src={secondSectionStart}></img>
      <div className="section-two-content-container">
        <div
          onLoad={singleCardOnload}
          ref={singleCardRef}
          className="single-card-container"
        >
          <SectionTwoCard
            singleCard={true}
            headerText=""
            titleText="За нас"
            contentText='"Нови Футболни Обувки" ЕООД
             внася маркови спортни стоки в България.
             От 3 години ние сме най-добрият спортен магазин в България.
             Нашата цел е да помагаме както на професионални футболисти, така и на любители на спорта.
             Ние предлагаме всякакви спортни стоки.'
            imgSingleCard={sectionTwoSignatureIcon}
          />
        </div>
        <div className="multy-card-container">
          <div
            ref={multiCardRef1}
            onLoad={multiCardOnload1}
            className="multy-card-container-cards1"
          >
            <SectionTwoCard
              multyCard={true}
              imgMultyCard={sectionTwoIcon1}
              titleText=""
              contentText=""
            />
            <SectionTwoCard
              multyCard={true}
              imgMultyCard={sectionTwoIcon2}
              titleText=""
              contentText=""
            />
          </div>
          <div
            ref={multiCardRef2}
            onLoad={multiCardOnload2}
            className="multy-card-container-cards2"
          >
            <SectionTwoCard
              multyCard={true}
              imgMultyCard={sectionTwoIcon3}
              titleText=""
              contentText=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
